import { memo } from 'react';

function NextStopComplianceStopMarker({ stopSequence, textColor, color, strokeColor, size = 29 }) {
  const shiftLeft = stopSequence && stopSequence < 10 ? 0 : -3;
  strokeColor = strokeColor || textColor;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <desc>Created with Sketch.</desc>
      <defs>
        <radialGradient cx="50%" cy="0%" fx="50%" fy="0%" r="100%" id="radialGradient-1">
          <stop stopColor="#0CD3C4" offset="0%" />
          <stop stopColor={color} offset="100%" />
        </radialGradient>
      </defs>
      <g id="Map-interactions" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Group-30" transform="translate(1.000000, 1.000000)">
          <circle
            id="Oval"
            stroke={strokeColor}
            fill={color}
            fillRule="nonzero"
            cx="11.5"
            cy="11.5"
            r="11.5"
          />
          <circle
            id="Oval"
            stroke={strokeColor}
            fill={color}
            fillRule="nonzero"
            cx="11.5"
            cy="11.5"
            r="11.5"
          />
          <text
            id={8}
            fontFamily="OpenSans-SemiBold, Open Sans"
            fontSize={10}
            fontWeight={500}
            fill={textColor}>
            <tspan x={8.5 + shiftLeft} y={15}>
              {stopSequence}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default memo(NextStopComplianceStopMarker);
